import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/t/billing/')({
  staticData: { breadcrumb: 'Billing' },
});
